/**
 * Regex to check ean barcodes
 * @type {RegExp}
 */

const ean = /^\d{13}$/

export default ean
